import { render, staticRenderFns } from "./AnimatedLogo.vue?vue&type=template&id=56deea2d"
var script = {}
import style0 from "./AnimatedLogo.vue?vue&type=style&index=0&id=56deea2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports